import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guaranteeChips } from '../data/salesCopy';
export function Guarantee() {
  return <section className="w-full border-b border-line bg-paper" data-id="element-101" data-mp="1o3dm4a5km9q3">
      <div className="mx-auto flex max-w-4xl flex-col gap-5 px-4 py-12 sm:flex-row sm:items-start sm:gap-8 sm:px-5 sm:py-14 lg:py-16" data-id="element-102" data-mp="223og3m26g4fh">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-moss/10 text-moss sm:h-14 sm:w-14" data-id="element-103" data-mp="1x54pv9gjw6hb">
          <ShieldCheckIcon className="h-6 w-6 sm:h-7 sm:w-7" aria-hidden="true" data-id="element-104" data-mp="14fo2wrbp9hsh" />
        </span>
        <div data-id="element-105" data-mp="1j4k72damyant">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-moss sm:text-xs" data-id="element-106" data-mp="1j4ahurxf07j6">
            Zero risk · 30 days protected
          </p>
          <h2 className="mt-2 font-display text-xl font-semibold leading-tight text-ink sm:mt-3 sm:text-3xl" data-id="element-107" data-mp="1ecixx08rl020">
            100% satisfaction or your money back
          </h2>
          <p className="mt-3 max-w-2xl text-[15px] leading-relaxed text-ink-soft sm:text-base" data-id="element-108" data-mp="lo4wsbmdpnm8">
            Try TeachersKit for 30 days. If your students aren’t more engaged, or if you don’t save
            at least 5 hours of planning a week, just email us. We’ll refund every cent — no
            questions asked.
          </p>
          <ul className="mt-5 flex flex-wrap gap-2 sm:mt-6" data-id="element-109" data-mp="yrfnmyytz1cd">
            {guaranteeChips.map(chip => <li key={chip} className="rounded-full border border-line bg-surface px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.1em] text-ink-soft sm:px-3.5 sm:text-xs" data-id="element-110" data-mp="12sr3wdvtea7w">
                {chip}
              </li>)}
          </ul>
          <p className="mt-4 text-sm font-medium text-ink-muted sm:mt-5" data-id="element-111" data-mp="f3opdewh8xhm">
            Satisfaction guaranteed, or your money back.
          </p>
        </div>
      </div>
    </section>;
}